import { Button, ButtonProps } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';
import { Optional } from '@/server/api/BaseService';
import { genericMemo } from '@/types/use';
import { AlertCircle, Ban, MoreHorizontal, Pencil } from 'lucide-react';
import { memo, ReactNode, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';

type BtnProps<T> = Optional<{
    isAllow: boolean;
    disabled?: boolean;
    icon: ReactNode;
    btnProps: ButtonProps;
    callback: (data: T) => any;
    confirmInfo?: {
        type: 'confirm' | 'del';
    };
}>;

export type TableButtonActionsProps<T = any> = {
    data: T;
    func: Partial<Record<string, BtnProps<T>>>;
};

const TableButtonActions = <T extends {}>(
    props: TableButtonActionsProps<T>
) => {
    const { data, func } = props;

    const btns: BtnProps<typeof data>[] = [];
    const keys = Object.keys(func);
    if (keys.length > 0) {
        for (let k of keys) {
            if (func[k]?.isAllow) {
                btns.push(func[k] as any);
            }
        }
    }
    return (
        <div className='flex h-full items-center justify-center'>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant='ghost' className='h-8 w-8 p-0'>
                        <span className='sr-only'>Open menu</span>
                        <MoreHorizontal className='h-4 w-4' />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align='end'>
                    <DropdownMenuLabel>Chức năng</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    {btns.map(
                        (
                            { icon, callback, confirmInfo, btnProps, disabled },
                            idx
                        ) => (
                            <DropdownMenuItem
                                className={cn(
                                    'cursor-pointer',
                                    btnProps?.className
                                )}
                                onClick={() => callback?.(data)}
                                key={idx}
                            >
                                <div className='flex items-center gap-2'>
                                    {icon}
                                    <span className='text-black dark:text-white'>
                                        {btnProps?.title}
                                    </span>
                                </div>
                            </DropdownMenuItem>
                        )
                    )}
                    <DropdownMenuItem
                        onClick={() => navigator.clipboard.writeText('123123')}
                    >
                        Sao chép ID
                    </DropdownMenuItem>
                    <DropdownMenuItem>Xem chi tiết</DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

export default genericMemo(TableButtonActions);
